import { FC } from 'react'
import reactStringReplace from 'react-string-replace'

import * as SC from '../styles'
import { Accordion, Icon, IconName, Link, Panel, PanelFace, TextBadge } from 'ui/components'
import { ChangesTable } from 'ui/temp/Changes'

import { ContactsChangesProps } from './ContactsChangesProps'

export const ContactsChanges: FC<ContactsChangesProps> = (props) => {
  const {
    data: {
      showContactsChanges: { showUpdated, showMissingInSAR, showMissingInOrbit }
    },
    showAll
  } = props

  const numberOfUpdateChanges = showUpdated?.reduce((sum, current) => sum + current.showChanges.length, 0)

  return (
    <Panel
      title="Contacts"
      titleTagAs="h3"
      face={PanelFace.SMALL_PRIMARY}
      isArrowButton
      rounded
      shadowed
      blockOnClickOnTitle={false}
      expanded={showAll}
    >
      {showMissingInSAR && (
        <Accordion
          title="Missing In SAR"
          expanded={showAll}
          actions={<TextBadge color="default">{showMissingInSAR.length} changes</TextBadge>}
          bottomPadding="small"
        >
          {showMissingInSAR.map((item, key) => {
            const { title, id } = item

            return (
              <SC.AccordionTitle key={key}>
                <Icon name={IconName.EXCLAMATION_ORANGE} />
                <span>
                  {reactStringReplace(title, /%#(.*)#%/g, (match, i) =>
                    id ? (
                      <Link key={i} to="/contacts/$contactId" params={{ contactId: id.toString() }}>
                        {match}
                      </Link>
                    ) : (
                      match
                    )
                  )}
                </span>
              </SC.AccordionTitle>
            )
          })}
        </Accordion>
      )}

      {showMissingInOrbit && (
        <Accordion
          title="Missing In Orbit"
          expanded={showAll}
          actions={<TextBadge color="default">{showMissingInOrbit.length} changes</TextBadge>}
          bottomPadding="small"
        >
          {showMissingInOrbit.map((item, key) => (
            <SC.AccordionTitle key={key}>
              <Icon name={IconName.EXCLAMATION_ORANGE} />
              {item}
            </SC.AccordionTitle>
          ))}
        </Accordion>
      )}

      {showUpdated && (
        <Accordion
          title="Updated"
          expanded={showAll}
          actions={<TextBadge color="default">{numberOfUpdateChanges} changes</TextBadge>}
          bottomPadding="small"
        >
          <SC.UpdateWrapper>
            {showUpdated.map((item, key) => {
              const { title, id, showChanges } = item

              return (
                <span key={key}>
                  <SC.AccordionTitle>
                    <Icon name={IconName.EXCLAMATION_ORANGE} />
                    <span>
                      {reactStringReplace(title, /%#(.*)#%/g, (match, i) => (
                        <Link key={i} to="/contacts/$contactId" params={{ contactId: id.toString() }}>
                          {match}
                        </Link>
                      ))}
                    </span>
                  </SC.AccordionTitle>
                  <ChangesTable changes={showChanges} dataQa="contact" />
                </span>
              )
            })}
          </SC.UpdateWrapper>
        </Accordion>
      )}
    </Panel>
  )
}
